import React, { useState, useContext } from "react";
import style from "./ModalInfoPrzerwa.module.css";
import iconX from "assets/x.svg";
import Zapisz from "./Zapisz";
import { reg_int, reg_txt } from "utils/initialvalue";
export default function ModalInfoPrzerwa({ showWindowInfoPrzerwa, setShowWindowInfoPrzerwa,selectedGrup }) {

  const [value, setValue] = useState("");

let oprawa= null;
  
  if (!showWindowInfoPrzerwa) return null;


 
    return (
      <div className={style.grayScaleBackground}>
        <div
          onDoubleClick={() => {
            console.table(selectedGrup)
            // console.log("daneKlienta : ");
          }}
          className={style.window}
        >
          <Header setShowWindowInfoPrzerwa={setShowWindowInfoPrzerwa} selectedGrup={selectedGrup}></Header>
          <div className={style.center}>
            <Info  value={value} setValue={setValue}  selectedGrup={selectedGrup}/>
          </div>
          <div className={style.footer}>
            <Zapisz grupaId={selectedGrup.global_id} setShowWindowInfoPrzerwa={setShowWindowInfoPrzerwa} uwagi={value} oprawa={selectedGrup.proces_nazwa_id}/>
          </div>
        </div>
      </div>
    );
  
}

function Header({ setShowWindowInfoPrzerwa,selectedGrup }) {
  return (
    <div className={style.header}
    >
      <p className={style.title}>Opis przerwy</p>
      <Zamknij setShowWindowInfoPrzerwa={setShowWindowInfoPrzerwa} />
    </div>
  );
}
function Zamknij({ setShowWindowInfoPrzerwa }) {
  return (
    <img
      className={style.zamknij_icon}
      src={iconX}
      onClick={() => {
        setShowWindowInfoPrzerwa(false);
      }}
      alt="Procesy"
    />
  );
}

function Info({ value,setValue,selectedGrup }) {
  return (
    <div className={style.labelinput}>
      {/* <label className={style.label}> Papier dostępny od: </label> */}
      <input
        className={style.firma}
        type="text"
        defaultValue={selectedGrup?.uwagi||""}
        onChange={(event) => {
            // const re = /^[a-zA-Z0-9_+\sąćęłńóśźżĄĘŁŃÓŚŹŻ./-]+$/;

  setValue(event.target.value)

          
          }}
      ></input>
    </div>
  );
}
